import { css } from 'lit';
export const accordionItemStyles = css `
    :host {
        display: block;
    }

    .hlx-accordion-item {
        color: var(--hlx-accordion-text-color-default);
    }

    .hlx-accordion-item-disabled {
        color: var(--hlx-accordion-text-color-disable);
    }

    .hlx-accordion-item-inverted {
        background-color: var(--hlx-background-color-inverted);
        color: var(--hlx-accordion-text-color-inverted-default);
    }

    .hlx-accordion-item-disabled.hlx-accordion-item-inverted {
        background-color: var(--hlx-background-color-inverted);
        color: var(--hlx-accordion-text-color-inverted-disabled);
    }

    .hlx-button-reset {
        appearance: none;
        border-radius: 0;
        text-align: inherit;
        background: none;
        box-shadow: none;
        padding: 0;
        cursor: pointer;
        border: none;
        color: inherit;
        font: inherit;
    }

    .hlx-accordion-item-title {
        width: 100%;
        padding-top: var(--hlx-spacing-xl);
        padding-bottom: var(--hlx-spacing-xl);
        position: relative;
        text-align: left;
        display: flex;
        align-items: baseline;
    }

    .hlx-accordion-item-title:focus-visible {
        outline: 2px solid var(--hlx-color-brand-default);
        outline-offset: 2px;
    }

    .hlx-accordion-item-title:hover {
        color: var(--hlx-accordion-text-color-hover);
    }
    .hlx-accordion-item-title:active {
        color: var(--hlx-accordion-text-color-active);
    }
    .hlx-accordion-item-title-disabled {
        cursor: not-allowed;
    }

    .hlx-accordion-item-title-disabled:hover {
        color: var(--hlx-accordion-text-color-disable);
    }

    .hlx-accordion-item-title-inverted:hover {
        color: var(--hlx-accordion-text-color-inverted-hover);
    }

    .hlx-accordion-item-title-inverted:active {
        color: var(--hlx-accordion-text-color-inverted-active);
    }

    .hlx-accordion-item-title-disabled.hlx-accordion-item-title-inverted:hover {
        color: var(--hlx-accordion-text-color-inverted-disabled);
    }

    .hlx-accordion-title-text {
        font-weight: var(--hlx-text-font-weight-semibold);
        font-size: var(--hlx-text-font-size-md);
        line-height: var(--hlx-text-line-height-default);
        letter-spacing: var(--hlx-text-letter-spacing-default);
    }

    .hlx-accordion-title-text-spaced {
        font-weight: var(--hlx-text-font-weight-normal);
        font-size: var(--hlx-text-font-size-lg);
    }

    .hlx-accordion-icon-slot {
        padding-right: var(--hlx-spacing-xs);
    }

    .hlx-accordion-panel-text {
        font-weight: var(--hlx-text-font-weight-normal);
        font-size: var(--hlx-text-font-size-md);
        line-height: var(--hlx-text-line-height-default);
        letter-spacing: var(--hlx-text-letter-spacing-default);
        color: var(--hlx-text-color-weak-1);
    }

    .hlx-accordion-panel-text.hlx-accordion-panel-text-inverted {
        color: var(--hlx-text-color-inverted-default);
    }

    .hlx-accordion-item-title-spaced {
        padding-top: var(--hlx-spacing-2xl);
        padding-bottom: var(--hlx-spacing-2xl);
    }

    .hlx-accordion-item-with-suffix-chevron {
        display: flex;
        flex: 1;
        align-items: baseline;
        justify-content: space-between;
    }

    .hlx-accordion-item-panel {
        display: grid;
        grid-template-rows: 0fr;
        transition: grid-template-rows 0.5s ease-out;
    }
    .hlx-accordion-item-panel-with-prefix-chevron {
        padding-left: 28px;
    }
    .hlx-accordion-item-panel-with-suffix-chevron {
        padding-right: 28px;
    }

    /*this is due to problem with css height animation
                 see https://www.stefanjudis.com/snippets/how-to-animate-height-with-css-grid/ */

    .hlx-accordion-item-panel-expanded {
        grid-template-rows: 1fr;
    }

    .hlx-accordion-item-panel-expanded.hlx-accordion-item-panel-condensed {
        padding-bottom: var(--hlx-spacing-xl);
    }

    .hlx-accordion-item-panel-expanded.hlx-accordion-item-panel-spaced {
        padding-bottom: var(--hlx-spacing-2xl);
    }

    .hlx-accordion-item-panel-inner {
        overflow: hidden;
    }

    .hlx-accordion-item-divider {
        border-top: 1px solid lightgray;
    }

    .hlx-accordion-item-chevron {
        color: var(--hlx-button-color-tertiary-brand-default);
    }
    .hlx-accordion-item-chevron:hover {
        color: var(--hlx-accordion-text-color-hover);
    }
    .hlx-accordion-item-chevron:active {
        color: var(--hlx-accordion-text-color-active);
    }

    .hlx-accordion-item-chevron-prefix {
        padding-right: var(--hlx-text-font-size-xs);
    }
    .hlx-accordion-item-chevron-suffix {
        padding-left: var(--hlx-text-font-size-xs);
    }

    .hlx-accordion-item-chevron-open {
        transform: rotate(180deg);
    }

    .hlx-accordion-item-chevron-hidden {
        display: none;
    }
`;
//# sourceMappingURL=accordion-item.styles.js.map